import Vue from 'vue'
import axios from './assets/js/api'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { ls } from './utils/common.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/receipt/index',
      name: 'home',
      meta: '首页',
      component: Home
    },
    {
      path: '/receipt/index/error',
      name: 'error',
      mata: '订单不存在',
      component: () => import(/* webpackChunkName: "about" */ './views/Error.vue')
    }
  ]
})
router.beforeEach((to, from, next) => {
  document.title = to.meta
  // 微信授权
  // 先判断是否在微信端
  let ua = navigator.userAgent.toLowerCase()
  if (ua.match(/micromessenger/i) && ua.match(/micromessenger/i)[0] === 'micromessenger') {
    if (ls.get('openid')) {
      next()
    } else {
      if (window.location.href.indexOf('code') !== -1) {
        axios.get('/auth', { params: to.query }).then(result => {
          if (!result.errcode) {
            ls.set('openid', result.openid)
            next()
          } else {
            console.log('error')
          }
        }).catch((err) => {
          console.log('err' + err)
        })
      } else {
        let APPID = 'wx11aa2e4f0951c676'
        let REDIRECT_URI = encodeURIComponent(window.location.href)
        let SCOPE = 'snsapi_base'
        let STATE = 'state'
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=${STATE}#wechat_redirect`
      }
    }
  } else {
    next()
  }
  // to and from are both route objects. must call `next`.
})
export default router
